(function () {
  var LOADING_CLASS = 'is-loading';
  var SWITCH_ATTR = 'data-switch-region';

  function shopifyRoot() {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base.slice(-1) === '/' ? base : base + '/';
  }

  function sectionsUrl(handle, sectionApiId) {
    return (
      shopifyRoot() +
      'products/' +
      encodeURIComponent(handle) +
      '?sections=' +
      encodeURIComponent(sectionApiId)
    );
  }

  function productJsUrl(handle) {
    return shopifyRoot() + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function sectionHtmlFromPayload(payload, sectionApiId, fallbackKey) {
    if (!payload || typeof payload !== 'object') return null;
    if (sectionApiId && payload[sectionApiId]) return payload[sectionApiId];
    if (fallbackKey && payload[fallbackKey]) return payload[fallbackKey];
    var keys = Object.keys(payload);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf('__main') !== -1) return payload[keys[i]];
    }
    return keys.length === 1 ? payload[keys[0]] : null;
  }

  function parseFetchedDoc(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function findMainRoot(doc, rootId) {
    if (!doc) return null;
    if (rootId) {
      var byId = doc.getElementById(rootId);
      if (byId) return byId;
    }
    return doc.querySelector('[id^="MainProduct-"]') || doc.querySelector('section[data-section]');
  }

  function replaceSwitchRegion(currentRoot, fetchedMainRoot) {
    if (!currentRoot || !fetchedMainRoot) return false;

    var newRegion = fetchedMainRoot.querySelector('[' + SWITCH_ATTR + ']');
    var curRegion = currentRoot.querySelector('[' + SWITCH_ATTR + ']');
    if (newRegion && curRegion) {
      curRegion.innerHTML = newRegion.innerHTML;
      return true;
    }

    var newGrid = fetchedMainRoot.querySelector('.product.grid');
    var curGrid = currentRoot.querySelector('.product.grid');
    if (newGrid && curGrid) {
      curGrid.innerHTML = newGrid.innerHTML;
      return true;
    }

    var newInfo = fetchedMainRoot.querySelector('product-info');
    var curInfo = currentRoot.querySelector('product-info');
    if (newInfo && curInfo) {
      curInfo.innerHTML = newInfo.innerHTML;
      return true;
    }

    return false;
  }

  function lockVariantGallery(sectionId) {
    var galleryRoot = document.getElementById('MainProduct-' + sectionId);
    if (!galleryRoot) return;

    function lockGallery(gallery) {
      if (!gallery || gallery.dataset.variantMediaLocked === 'true') return;
      if (typeof gallery.setActiveMedia !== 'function') return;
      var original = gallery.setActiveMedia.bind(gallery);
      gallery.setActiveMedia = function (mediaId, prepend) {
        if (prepend) return;
        return original(mediaId, prepend);
      };
      gallery.dataset.variantMediaLocked = 'true';
    }

    galleryRoot.querySelectorAll('[id^="MediaGallery-"]').forEach(lockGallery);
  }

  function afterSwap(root) {
    var sectionId = root.getAttribute('data-section');
    if (sectionId) lockVariantGallery(sectionId);

    var idInput = root.querySelector(
      'input.product-variant-id[name="id"], input[name="id"][data-productid]'
    );
    if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));

    document.dispatchEvent(
      new CustomEvent('melati:product-switched', {
        detail: { sectionId: sectionId, root: root },
      })
    );
  }

  function updateHistory(url) {
    if (!url) return;
    try {
      var next = new URL(url, window.location.origin).pathname;
      if (window.location.pathname !== next) {
        window.history.replaceState({}, '', next);
      }
    } catch (e) {
      /* ignore */
    }
  }

  function setActiveCard(lpc, handle) {
    if (!lpc) return;
    lpc.querySelectorAll('.lpc-card').forEach(function (card) {
      var on = card.getAttribute('data-product-handle') === handle;
      card.classList.toggle('active', on);
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    lpc.setAttribute('data-current-handle', handle);
  }

  function fetchSectionHtml(handle, sectionApiId, fallbackKey) {
    return fetch(sectionsUrl(handle, sectionApiId), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Section request failed: ' + r.status);
        return r.json();
      })
      .then(function (json) {
        var html = sectionHtmlFromPayload(json, sectionApiId, fallbackKey);
        if (!html) throw new Error('Section HTML missing in response');
        return html;
      });
  }

  function applySectionHtml(html, root, rootId, lpc, handle, productUrl) {
    var doc = parseFetchedDoc(html);
    var fetchedMain = findMainRoot(doc, rootId);
    if (!fetchedMain) throw new Error('Main product root not found in section HTML');

    if (!replaceSwitchRegion(root, fetchedMain)) {
      throw new Error('Could not replace product content region');
    }

    scan();
    var freshLpc = root.querySelector('.lpc[id^="LinkedProductCards-"]');
    if (freshLpc) setActiveCard(freshLpc, handle);

    afterSwap(root);
    if (productUrl) updateHistory(productUrl);

    var titleEl = root.querySelector('.product__title h1');
    if (titleEl) document.title = titleEl.textContent.trim();
  }

  function applyProductJsFallback(handle, root, lpc) {
    return fetch(productJsUrl(handle), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Product JS failed');
        return r.json();
      })
      .then(function (product) {
        var titleEl = root.querySelector('.product__title h1');
        if (titleEl) titleEl.textContent = product.title;

        var desc = root.querySelector('.product__description');
        if (desc && product.description) desc.innerHTML = product.description;

        var variant = product.variants && product.variants[0];
        if (variant) {
          root.querySelectorAll('input[name="id"][data-productid]').forEach(function (input) {
            input.value = variant.id;
            input.setAttribute('data-productid', String(product.id));
          });
          var jsonEl = root.querySelector('[id^="ProductVariantsJson-"]');
          if (jsonEl) jsonEl.textContent = JSON.stringify(product.variants);
        }

        var info = root.querySelector('product-info');
        if (info && product.url) info.setAttribute('data-url', product.url);

        if (product.featured_image && product.images && product.images.length) {
          var src = product.featured_image;
          root.querySelectorAll('.product__media-item img, .product__modal img').forEach(function (img, i) {
            if (i === 0) {
              img.src = src;
              img.removeAttribute('srcset');
            }
          });
        }

        setActiveCard(lpc, handle);
        afterSwap(root);
        if (product.url) updateHistory(product.url);
        document.title = product.title;
      });
  }

  function switchProduct(lpc, handle) {
    if (!handle || handle === lpc.getAttribute('data-current-handle')) return false;

    var sectionApiId = lpc.getAttribute('data-section-api-id');
    var fallbackKey = lpc.getAttribute('data-section-key') || 'main-product';
    var rootId = lpc.getAttribute('data-root-id');
    var root = document.getElementById(rootId);
    if (!root) return false;

    if (!sectionApiId) {
      console.error('[linked-product-cards] Missing data-section-api-id on .lpc');
      return false;
    }

    var card = lpc.querySelector('.lpc-card[data-product-handle="' + handle + '"]');
    var productUrl = card ? card.getAttribute('data-product-url') : null;

    lpc.querySelectorAll('.lpc-card').forEach(function (c) {
      c.classList.add(LOADING_CLASS);
    });

    fetchSectionHtml(handle, sectionApiId, fallbackKey)
      .then(function (html) {
        applySectionHtml(html, root, rootId, lpc, handle, productUrl);
      })
      .catch(function (err) {
        console.warn('[linked-product-cards] Section swap failed, trying product.js fallback', err);
        return fetchSectionHtml(handle, fallbackKey, sectionApiId).then(function (html) {
          applySectionHtml(html, root, rootId, lpc, handle, productUrl);
        });
      })
      .catch(function (err2) {
        console.warn('[linked-product-cards] Second section key failed, partial update', err2);
        return applyProductJsFallback(handle, root, lpc);
      })
      .catch(function (err3) {
        console.error('[linked-product-cards] Could not swap product in place', err3);
      })
      .finally(function () {
        root.querySelectorAll('.lpc-card').forEach(function (c) {
          c.classList.remove(LOADING_CLASS);
        });
      });

    return true;
  }

  function initLpc(lpc) {
    if (!lpc || lpc.dataset.lpcBound === 'true') return;
    lpc.dataset.lpcBound = 'true';

    lpc.addEventListener('click', function (event) {
      var card = event.target.closest('.lpc-card');
      if (!card || card.classList.contains('active')) return;
      event.preventDefault();
      event.stopPropagation();
      var handle = card.getAttribute('data-product-handle');
      switchProduct(lpc, handle);
    });
  }

  function scan() {
    document.querySelectorAll('.lpc[id^="LinkedProductCards-"]').forEach(initLpc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
